import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import { Link as MuiLink } from "@material-ui/core";

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { useStyles } from "./SignUpForm.css";
import FormLoader from "../../../../../Component/FormLoader/FormLoader";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#0a1f3a",
    },
  },
});

class SignUpForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      showConfirmPassword: false,
      termsAccept: false,
    };
  }

  handleChangeTerms = (e) => {
    this.setState({
      termsAccept: e.target.checked,
    });
  };

  showPassword = () => {
    return (
      <Visibility
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: true })}
      />
    );
  };

  hidePassword = () => {
    return (
      <VisibilityOffIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: false })}
      />
    );
  };

  showConfirmPassword = () => {
    return (
      <Visibility
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showConfirmPassword: true })}
      />
    );
  };

  hideConfirmPassword = () => {
    return (
      <VisibilityOffIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showConfirmPassword: false })}
      />
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Typography variant="h5" className={classes.title}>
          <div>{this.props.label}</div>
          <div>
            <strong>SignUp</strong>
          </div>
        </Typography>

        <TextField
          name="firstName"
          type="text"
          label="First Name"
          required
          margin="normal"
          variant="outlined"
          placeholder="Enter First Name"
          style={{ marginRight: this.props.label === "Customer" ? 15 : 20 }}
          className={
            this.props.label === "Customer"
              ? classes.nameCustomerStyle
              : classes.nameAuthorStyle
          }
          error={this.props.error.firstNameError ? true : false}
          helperText={this.props.error.firstNameError}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={this.props.data.firstName}
          onChange={this.props.handleChange}
        />

        {this.props.label === "Author" && (
          <TextField
            name="middleName"
            type="text"
            label="Middle Name"
            margin="normal"
            variant="outlined"
            placeholder="Enter Middle Name"
            style={{ marginRight: 20 }}
            className={classes.nameAuthorStyle}
            helperText="This is optional."
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.props.data.middleName}
            onChange={this.props.handleChange}
          />
        )}

        <TextField
          name="lastName"
          type="text"
          label="Last Name"
          required
          margin="normal"
          variant="outlined"
          placeholder="Enter Last Name"
          className={
            this.props.label === "Customer"
              ? classes.nameCustomerStyle
              : classes.nameAuthorStyle
          }
          error={this.props.error.lastNameError ? true : false}
          helperText={this.props.error.lastNameError}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={this.props.data.lastName}
          onChange={this.props.handleChange}
        />

        {this.props.label === "Author" && (
          <React.Fragment>
            <TextField
              name="description"
              type="string"
              label="Bio"
              required
              multiline
              fullWidth
              margin="normal"
              rows={4}
              rowsMax={8}
              variant="outlined"
              placeholder="Describe about yourself"
              style={{ outline: "none" }}
              error={this.props.error.descriptionError ? true : false}
              helperText={this.props.error.descriptionError}
              InputProps={{
                classes: {
                  focused: classes.focused,
                  notchedOutline: classes.notchedOutline,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              value={this.props.data.description}
              onChange={this.props.handleChange}
            />
          </React.Fragment>
        )}

        <TextField
          name="email"
          type="email"
          label="Email"
          fullWidth
          required
          margin="normal"
          variant="outlined"
          style={{ outline: "none" }}
          placeholder="Enter email address"
          error={this.props.error.emailError ? true : false}
          helperText={this.props.error.emailError}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          className={`${
            this.props.label === "Author" && classes.inputWithMargin
          }`}
          value={this.props.data.email}
          onChange={this.props.handleChange}
        />
        {this.props.label === "Author" && (
          <TextField
            name="phone"
            type="tel"
            label="Phone Number"
            fullWidth
            required
            margin="normal"
            variant="outlined"
            placeholder="Enter Phone Number"
            style={{ outline: "none" }}
            error={this.props.error.phoneError ? true : false}
            helperText={this.props.error.phoneError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            className={classes.inputWithoutMargin}
            value={this.props.data.phone}
            onChange={this.props.handleChange}
          />
        )}
        <TextField
          name="password"
          type={this.state.showPassword ? "text" : "password"}
          label="Password"
          fullWidth
          required
          margin="normal"
          variant="outlined"
          placeholder="Enter desired password"
          style={{ outline: "none" }}
          error={this.props.error.passwordError ? true : false}
          helperText={this.props.error.passwordError}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
            endAdornment: this.state.showPassword
              ? this.hidePassword()
              : this.showPassword(),
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          className={classes.inputWithMargin}
          value={this.props.data.password}
          onChange={this.props.handleChange}
        />

        <TextField
          name="confirmPassword"
          type={this.state.showConfirmPassword ? "text" : "password"}
          label="Confirm Password"
          fullWidth
          required
          margin="normal"
          variant="outlined"
          placeholder="Confirm the password"
          style={{ outline: "none" }}
          error={this.props.error.confirmPasswordError ? true : false}
          helperText={this.props.error.confirmPasswordError}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
            endAdornment: this.state.showConfirmPassword
              ? this.hideConfirmPassword()
              : this.showConfirmPassword(),
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          className={classes.inputWithoutMargin}
          value={this.props.data.confirmPassword}
          onChange={this.props.handleChange}
        />

        <div component="fieldset" className={classes.termStyle}>
          <ThemeProvider theme={theme}>
            <Checkbox
              color="primary"
              checked={this.state.termsAccept}
              onChange={this.handleChangeTerms}
              name="termsAccept"
            />
          </ThemeProvider>
          <div>
            I accept all the &nbsp;
            {
              <MuiLink href={"/termsandcondition"}>
                terms and conditions
              </MuiLink>
            }
            .
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "center" }}>
          {this.state.termsAccept ? (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="submit"
                variant="outlined"
                className={classes.buttonStyle}
              >
                SignUp
              </Button>
              {this.props.loading && <FormLoader />}
            </div>
          ) : (
            <Button
              disabled
              variant="outlined"
              style={{
                textTransform: "none",
                fontSize: 18,
                color: "#eee",
                borderRadius: 20,
              }}
            >
              SignUp
            </Button>
          )}
        </div>
      </form>
    );
  }
}

export default withStyles(useStyles)(withRouter(SignUpForm));
